import React from 'react';
import { connect } from "react-redux";
import { setConversationActive } from '../../stories/actions';

import Label from '../Labels/Label';

import "./Room.css";

const ParticipantSingle = ({ identity, isRoomListener }) => {
    return (!isRoomListener) && (
        <div className="user_single_container">
            <span className="material-symbols-outlined icon_user_single">person</span>
            <span className="name_user_single">{identity}</span>
        </div>
    );
};

const Participants = ({ participants, isRoomListener }) => {
    return (
        <div className='row mb-2 users_loggeds_container'>
            <Label text="PARTICIPANTES" />

            <div className="col-md-12 mb-2 participants_list">
                {participants.filter((participant, index, self) => index === self.findIndex((u) => (
                    u.identity === participant.identity
                ))).map((participant, index) => (
                    <ParticipantSingle
                        key={`${participant.identity}-${index}`}
                        identity={participant.identity}
                        isRoomListener={isRoomListener}
                    />
                ))}
            </div>
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

const mapActionToProps = (dispatch) => {
    return {
        setConversationActiveAction: (conversationActive) => dispatch(setConversationActive(conversationActive)),
    };
};

export default connect(mapStoreToProps, mapActionToProps)(Participants);
